import React from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { RestaurantResponse } from '@/api/lib/restaurant';
import { TextInput } from '@/components/forms/base/TextInput';
import { Form } from '@/components/forms/core/Form';
import { Button } from '@/components/molecules/Button';

import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { useUpdateRestaurantMutation } from '@/api/hooks/useRestaurant';
import { UpdateRestaurantSchemaType, validationSchema } from '../RestaurantForm/schema';

export interface SocialNetworkFormProps {
  restaurant?: RestaurantResponse;
}

export const SocialNetworkForm = ({ restaurant }: SocialNetworkFormProps) => {
  const { t } = useTranslation();

  const { isLoading, mutateAsync: updateSocialNetworkRestaurant } = useUpdateRestaurantMutation({
    onSuccess: () => {
      toast.success(t('action.restaurantUpdated'), {
        position: 'bottom-right'
      });
    }
  });

  const handleSubmit = async (data: UpdateRestaurantSchemaType) => {
    if (!restaurant?.id) {
      toast.error(t('proposeRestaurant.pleaseSelectRestaurant'), {
        position: 'bottom-right'
      });
      return;
    }

    await updateSocialNetworkRestaurant({ ...data, restaurantId: restaurant?.id });
  };

  return (
    <div className="gap-4 flex flex-col w-full">
      <Form
        data-testid="restaurant-form"
        schema={validationSchema(t)}
        onSubmit={handleSubmit}
        className="flex flex-col gap-5"
        defaultValues={{
          instagramLink: restaurant?.socialMedia?.instagram,
          facebookLink: restaurant?.socialMedia?.facebook
        }}
        onlyTouchedFields={false}
        render={({ formState }) => {
          return (
            <>
              <div className="grid md:grid-cols-2 gap-2 md:gap-x-12">
                <TextInput
                  id="instagramLink"
                  leftIcon={<FaInstagram className="text-orange-700" />}
                  label={t('form.instagram')}
                  placeholder="www.instagram.com/monrestohalal/"
                />
                <TextInput
                  id="facebookLink"
                  leftIcon={<FaFacebook className="text-blue-800" />}
                  label={t('form.facebook')}
                  placeholder="www.facebook.com/monrestohalal/"
                />
              </div>

              <div>
                <Button fullWidth type="submit" color="primary" label={t('form.save')} loading={isLoading} disabled={!formState.isDirty} />
              </div>
            </>
          );
        }}
      />
    </div>
  );
};
